<template>
  <container class="open-modal">
    <div class="overlay"></div>
    <modalRegister class="box">
      <div class="close-modal" @click="closeModal"> 
        <div>
          <span >
            <img src="https://www.iouu.com.br/hubfs/raw_assets/public/IOUU_November2020/images/close-blue.svg" class="" alt="Close Icon" title="Close Icon">
          </span>
        </div>
      </div>

      <div class="body">
        <span >
          <h2>O que deseja?</h2>
          <p>Conectamos empresas à procura de crédito com investidores com dinheiro para emprestar.</p>
          <ul>
            <li>
              <a target="_blank" href="https://dashboard-app.iouu.com.br/?__hstc=45338044.f24ee702a737cb6e1fa1f448473525de.1606915619443.1608212397141.1608224135495.4&amp;__hssc=45338044.1.1608224135495&amp;__hsfp=2008320709#/criar-conta" class="btn" rel="noopener">
                Quero Investir
              </a>
            </li>
            <li>
              <a target="_blank" href="https://emprestimos.iouu.com.br/pedido" class="btn" rel="noopener">
                Quero Empréstimo
              </a>
            </li>
          </ul>
        </span>
      </div>
        
    </modalRegister>
  </container>
  
</template>

<script>
export default {

  methods: {
    closeModal() {
      this.$emit("setCloseOpenModal")
    }
  }
  
}
</script>

<style lang="scss" scoped>

container {
  position: relative;
  overflow: hidden;
  transform: translateY(0px);
  transition: all .3s;
  z-index: 100;

  & .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.3);
    z-index: 1;
  }

  & .box {
    z-index: 100;
    background-color: #fff;
    width: 641px;
    height: 448px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 106px 74px;
    border-radius: 8px;
    position: absolute;
    left: calc(50vw - 321px);
    top: calc(50vh - 224px);
  
    & .close-modal {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    &>div:last-child {
      width: 100%;
    }

    & h2 {
      margin-bottom: 28px;
      text-align: center;
    }

    & p {
      margin-left: auto;
      margin-right: auto;
      margin-bottom: 52px;
      max-width: 416px;
      text-align: center;   
    }

    & ul {
      width: 100%;
      display: flex;
      align-items: center;
    }

    & ul li:first-child {
      margin-right: 9px;
    }

    & ul li {
      width: 50%;
    }

    & ul li a {
      width: 100%;
      color: #fff;
    }

    .btn {
      width: 238px;
      height: 64px;
      background-color: #41d3bd;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .3s;
    }

    .btn:hover {
      transition: all .3s;
      background-color: #21247f;
    }

    & ul li:last-child a {
      text-align: center;
      background-color: transparent !important;
      border: 1px solid #41d3bd;
      border-radius: 8px;
      color: #41d3bd;
    }

    & ul li:last-child a:hover {
      transition: all .3s;
      border: 1px solid #21247f;
      color: #21247f;
    }

    & .body {
      & h2 {
        color: #2c3236;
        font-size: 40px;
        font-weight: 700;
      }

      & p {
        color: #818495;
        font-weight: 400;
        font-size: 18px;
      }
    }
  }

}

</style>


// WEBPACK FOOTER //
// src/components/NewModal/ModalRegistration.vue